import styled from 'styled-components';
import { removeScrollbar } from '@/styles/helpers';

export const Box = styled.div<{
  $isHomePage?: boolean;
}>`
  ${removeScrollbar()}

  display: flex;
  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.palette.primary.background};
  width: 1000px;
  padding: 20px 20px 15px;
  gap: 20px calc((100% - (105px * 8)) / 7);
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 20px 40px 15px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    gap: 5px;
    padding: ${({ $isHomePage }) => ($isHomePage ? '0 0 15px' : '0 5px 15px')};
    flex-wrap: nowrap;
    width: 100vw;
    overflow-x: auto;
  }
`;
